import gql from "graphql-tag";

export const GetSubscriptionLimit = gql`
  query GetSubscriptionLimit {
    accounts {
      usageStats {
        videoCount
        opportunityCount
      }
      subscription {
        subscriptionPlan {
          id
          nickname
          videoLimit
          opportunityLimit
        }
      }
    }
  }
`;
